export default "__VITE_ASSET__B19O1xlM__"